
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './button.component';
import utils from '../features/utils';

interface ErrorSsoProps {
  error: string
}

export const ErrorSso = ( { error }: ErrorSsoProps ) => {

  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 text-center">
      <h1 className='text-lg text-gray-800' >
        { t( 'SSO connection error' ) }
      </h1>
      <p className='text-sm text-gray-600'>
        { error }
      </p>
      <div className='mx-10'>
        <Button
          label={ t( 'Try again' ) }
          action={ () => {
            const redirectUrl = encodeURIComponent( utils.getRedirectUrl() );
            window.location.replace( window.location.href.split( '?' )[ 0 ] + ( redirectUrl != '' ? '?redirect_url=' + redirectUrl : '' ) );
          } }
        />
      </div>
    </div>
  );
};